import { useParams } from 'react-router-dom';

export const useProjectParams = () => {
  const { projectId } = useParams<{ projectId: string }>();
  return { projectId };
};
